import { buildProps, definePropType } from '@sgui-plus/utils/props'
import type Card from './card.vue'
import type { ExtractPropTypes } from 'vue'
import type { StyleValue } from '@sgui-plus/utils/types'

export const cardProps = buildProps({
  header: {
    type: String,
    default: '',
  },
  bodyStyle: {
    type: definePropType<StyleValue>([String, Object, Array]),
    default: '',
  },
  shadow: {
    type: String,
    default: 'always',
  },
  transparent: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
} as const)

export type CardProps = ExtractPropTypes<typeof cardProps>
export type CardInstance = InstanceType<typeof Card>
